import HlsVideoPlayer from "@/components/hsl-video-player";
import { cn } from "@/lib/utils";

import { OptimizedImage } from "./ui/image";

export function PostMedia({
  media,
  altText = "Post media",
  className = "",
  poster,
}: {
  media: MediaContent[];
  altText?: string;
  className?: string;
  poster?: string;
}) {
  if (!media || !media.length)
return null;

  const count = media.length;

  return (
    <div
      className={cn(
        "rounded-lg overflow-hidden",
        { "grid grid-cols-1 md:grid-cols-2 gap-2 ": media.length > 1 },
        className,
      )}
    >
      {media.map((m, index) => {
        const key = m.id || index;

        if (m.type === "image") {
          return (
            <OptimizedImage
              key={key}
              src={m.url}
              alt={altText}
              width={800}
              height={400}
              className={cn(
                "w-full h-full object-cover",
                count === 1 ? "rounded-lg" : "rounded-md",
              )}
            />
          );
        }

        if (m.type === "video") {
          return (
            <HlsVideoPlayer
              key={key}
              src={`https://res.cloudinary.com/${process.env.NEXT_PUBLIC_CLOUD_NAME}/video/upload/sp_auto/v1751778607/${m.url}.m3u8`}
              className={cn(
                "w-full h-full object-cover",
                count === 1 ? "rounded-lg" : "rounded-md",
              )}
              poster={poster}
            />
          );
        }

        return null;
      })}
    </div>
  );
}
